<template>
  <section>
    <Toolbar />
    <!--<v-row justify="center" class="ma-0 pa-0">
      <v-col
        cols="11"
        xs="11"
        sm="11"
        md="12"
        lg="12"
        xl="12"
        class="ma-0 pa-0"
      >
         <h2 class="texto-titulo text-center font-weight-bold">
          Estatus de tu crédito dígital
        </h2> 
      </v-col>
    </v-row>-->
    <v-row justify="center" class="ma-0 pa-0">
      <v-col cols="9" class="ma-0 mb-0" style="position: relative">
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1">
            Solicitud enviada
            <!-- <small>Summarize if needed</small> -->
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card class="mb-12">
              <v-card-text>
                Tu solicitud fue enviada, pronto un asesor la revisará y te
                responderemos en breve
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2">
            En revisión de tu solicitud
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card class="mb-12">
              <v-card-text>
                Estamos validando la información de tu solicitud, se paciente y
                te responderemos en breve
              </v-card-text>
            </v-card>
            <!-- <v-btn color="primary" @click="e6 = 3"> Continue </v-btn>
            <v-btn text> Cancel </v-btn> -->
          </v-stepper-content>

          <v-stepper-step
            :complete="e6 > 3"
            step="3"
            :rules="[
              (value) => {
                false
              },
            ]"
            v-if="e6 == 3"
          >
            Solicitud rechazada
          </v-stepper-step>

          <v-stepper-content step="3" v-if="e6 == 3">
            <v-card class="mb-12">
              <v-card-text>
                Tu solicitud no cumplio con los requisitos y ha sido rechazada.
              </v-card-text>
            </v-card>
            <!-- <v-btn color="primary" @click="e6 = 3"> Continue </v-btn>
            <v-btn text> Cancel </v-btn> -->
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 4" step="4">
            Crédito Depositado
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-card class="mb-12">
              <v-card-text>
                Tu dinero se encuentra depositado en tu cuenta de débito de Caja
                Morelia Valladolid.
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="5" :complete="e6 > 5">
            Activación banca en linea
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-card class="mb-12">
              <v-card-text>
                Activa tu banca electronica siguiendo las intrucciones en tu
                correo electronico o acudiendo a tu sucursal más cercana
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="6">
            Recolección de tarjeta de débito
          </v-stepper-step>
          <v-stepper-content step="6">
            <v-card class="mb-12">
              <v-card-text>
                Ve a tu sucursal más cercana por tu tarjeta de débito visa y
                dispon tu dinero directamente en cajeros y terminales de venta
              </v-card-text>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row justify="center" class="ma-0 pa-0 mt-2">
      <v-col cols="8" class="ma-0 pa-0 mb-5">
        <br />
        <p class="text-center grey--text text--darken-2 ma-0 pa-0">
          Tu información está segura: Puedes cerrar esta ventana en cualquier
          momento.
        </p>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-3 mb-3 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <p class="text-center grey--text text--darken-2 ma-0">
          ¿Dudas? Contáctanos
          <!--via Whatsapp o al telefono
          <a href="tel:8003000268"
            ><br />
            800-3000-268</a
          >
           <br />800-3000-268<br /> -->
          <!-- <router-link
            :to="{ name: 'cancelacion' }"
            class="text-body-30 font-weight-bold"
            >Haz click aqui</router-link
          > -->
        </p>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-0 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
    >
      <v-col cols="5" class="ma-0 pa-0" align="right">
        <v-btn
          class="align-self-right"
          color="primary"
          v-bind="attrs"
          v-on="on"
          elevation="3"
          @click="whats"
          >Mensaje<v-icon right light>mdi-whatsapp</v-icon></v-btn
        >
      </v-col>
      <v-col cols="1"></v-col>
      <v-col cols="5" class="ma-0 pa-0">
        <v-btn
          class="align-self-center"
          color="primary"
          v-bind="attrs"
          v-on="on"
          elevation="3"
          @click="llamar"
          >Llamar<v-icon right light>mdi-phone</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SeguimientoAvance',
  // props: () => ({
  //   fix: Number,
  // }),
  data: () => ({
    e6: 3,
    solicitud: null,
  }),
  computed: {
    ...mapGetters({
      obtenerPersona: 'persona/obtenerPersona',
      obtenerCredito: 'credito/obtenerCredito',
      obtenerEstatusSol: 'credito/obtenerEstatusSol',
    }),
  },
  components: {
    Toolbar,
  },
  created() {
    // if (this.fix != null) this.e6 = this.fix
    // else {
    this.solicitud = this.obtenerEstatusSol
    this.e6 = this.paso()
    // }
  },
  methods: {
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
    whats() {
      // window.location.href = 'https://wa.me/5215510695948'
      window.open('https://wa.me/5215510695948', '_blank')
    },
    llamar() {
      // window.location.href = 'tel:8003000268'
      window.open('tel:8003000268', '_blank')
    },
    paso() {
      switch (this.solicitud.estatus) {
        case 1:
          return 1
        case 2:
          // switch (this.solicitud.substatus) {
          //   case 2:
          //     return 2
          //   case 3:
          //     return 4
          //   case 4:
          //     return 2
          //   case 5:
          //     return 2
          //   case 6:
          //     return 2
          // }
          // break
          return 2
        case 3:
          switch (this.solicitud.banca_activa) {
            case 1:
              return 6
            case 0:
              return 5
          }
          break
        case 4:
          return 3
        case 5:
          return 3
      }
    },
  },
}
</script>

<style scoped></style>
